import { PINNED_COLUMN } from '@constants'
import { RestrictionData } from '@types'

export const isColumnPinnedByAdmin = (
  columnCode: string | undefined,
  defaultEntityRestrictions?: RestrictionData
): boolean => {
  if (!columnCode) {
    return false
  }

  return Boolean(
    defaultEntityRestrictions?.fix?.some(
      item =>
        item.fieldCode === columnCode &&
        (item.value === PINNED_COLUMN.LEFT || item.value === PINNED_COLUMN.RIGHT)
    )
  )
}
